import script from "./tagSelector2.vue?vue&type=script&setup=true&lang=js"
export * from "./tagSelector2.vue?vue&type=script&setup=true&lang=js"

import "./tagSelector2.vue?vue&type=style&index=0&id=3e09fbe6&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e09fbe6"]])

export default __exports__